import { gql } from '@apollo/client';

export const FETCH_CART = gql`
  query fetchCart($cartId: ID!) {
    cart(id: $cartId) {
      id
      checkoutUrl
      totalQuantity
      cost {
        checkoutChargeAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
      lines(first: 10) {
        edges {
          node {
            id
            quantity
            attributes {
              key
              value
            }
            merchandise {
              ... on ProductVariant {
                id
                title
                sku
                image {
                  url
                }
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
                metafields(
                  identifiers: [
                    { namespace: "custom", key: "is_preorder" }
                    { namespace: "custom", key: "preorder_date" }
                    { namespace: "custom", key: "preorder_discount" }
                  ]
                ) {
                  namespace
                  key
                  value
                }
                product {
                  id
                  productType
                  title
                  handle
                }
              }
            }
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
                currencyCode
              }
              remainingBalanceChargeAmount {
                amount
                currencyCode
              }
              priceAdjustments {
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                perDeliveryPrice {
                  amount
                  currencyCode
                }
                unitPrice {
                  amount
                  currencyCode
                }
              }
              sellingPlan {
                id
                name
                description
                recurringDeliveries
                options {
                  name
                  value
                }
                priceAdjustments {
                  orderCount
                  adjustmentValue {
                    ... on SellingPlanPercentagePriceAdjustment {
                      adjustmentPercentage
                    }
                    ... on SellingPlanFixedAmountPriceAdjustment {
                      adjustmentAmount {
                        amount
                        currencyCode
                      }
                    }
                    ... on SellingPlanFixedPriceAdjustment {
                      price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
